import { render, staticRenderFns } from "./project-auth.vue?vue&type=template&id=d4cd643e&scoped=true&"
import script from "./project-auth.vue?vue&type=script&lang=js&"
export * from "./project-auth.vue?vue&type=script&lang=js&"
import style0 from "./project-auth.vue?vue&type=style&index=0&id=d4cd643e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cd643e",
  null
  
)

export default component.exports